export default __webpack_public_path__ + "static/media/element_14.86c92671.webp";